(function($) {

    $.fn.priceform = function (options) {
        
        var $elem = this;
        var settings = $.extend({
            copies_template: '{copies} x EUR {price}',
            price_template: 'EUR {price}',
            total_template: 'EUR {price}',
            tax_template: 'EUR {price}',
            discount_template: "EUR -{discount}",
            quantity_template: "EUR -{discount}",
            max_copies: 25,
            tax: 0.21,
        }, options);

        var price = settings.price;
        var $copies = $elem.find('.order-copies > input');
        var $subscribe = $elem.find('#subscribe');
        var shipping = settings.shipping;
        var tax = settings.tax;
        var discount = 0;
        var codes = [];
        var shipping_options = settings.shipping_options;
        var white_price = 0;

        var quantity_discount = {
            1: [9900, 0, 9900],
            2: [19800, 2000, 17800],
            3: [29700, 4000, 25700],
            4: [39600, 6000, 33600],
            5: [49500, 9000, 40500],
            6: [59400, 12000, 47400],
            7: [69300, 15000, 54300],
            8: [79200, 18000, 61200],
            9: [89100, 21000, 68100],
            10: [99000, 24000, 75000],
            11: [108900, 27000, 81900],
            12: [118800, 30000, 88800],
            13: [128700, 33000, 95700],
            14: [138600, 36000, 102600],
            15: [148500, 39000, 109500],
            16: [158400, 42000, 116400],
            17: [168300, 45000, 123300],
            18: [178200, 48000, 130200],
            19: [188100, 51000, 137100],
            20: [198000, 54000, 144000],
            21: [207900, 57000, 150900],
            22: [217800, 60000, 157800],
            23: [227700, 63000, 164700],
            24: [237600, 66000, 171600],
            25: [247500, 69000, 178500]
        };

        $elem.find('.order-form').submit(function(e) {
            var copies = parseInt($copies.val());
            var subscribe = $subscribe.val();
            $(this).find('input[name="subscribe"]').val(subscribe);
            $(this).find('input[name="copies"]').val(copies);
        });

        // $elem.find('#shipping-input').on("select2:select", function (e) {
        //     calculatePrice(parseInt($copies.val()));
        // });

        $elem.find('.order-payment-button').click(function(e) {
        e.preventDefault();

            if($elem.find('#terms').prop('checked')) {
                $(this).off('click');
                $elem.find('.order-copies').submit();
            } else {
                $elem.find('.terms-error').show();
            }
        });

        $elem.find('#terms').click(function() {
            $elem.find('.terms-error').hide();
        });

        $elem.find('.order-copies-add').click(function(e) {
            e.preventDefault();
            var copies = parseInt($copies.val());
            copies++;
            $copies.val(copies);
            $copies.change();
        });

        $elem.find('.order-copies-remove').click(function(e) {
            e.preventDefault();
            var copies = parseInt($copies.val());
            copies--;
            $copies.val(copies);
            $copies.change();
        });

        $elem.find('.order-copies-apply').click(function(e)
        {
            $('#promo-input').removeClass('error');
            e.preventDefault();
            var copies = parseInt($copies.val());
            var code = $('#promo-input').val();
            if($.inArray(code, codes) == -1) codes.push(code);
            calculatePrice(copies);
        });

        $elem.find('#colour').change(function(){
            $copies.change();
        });

        $elem.find('#priority-input').change(function(){
            $copies.change();
        });

        $copies.change(function() {
            var copies = parseInt($copies.val());
            if(isNaN(copies)) copies = 1;
            copies = Math.min(copies, settings.max_copies);
            copies = Math.max(copies, 1);
            $(this).val(copies);
            calculatePrice($(this).val());
        }).change();

        function calculatePrice(copies) {
            copies = parseInt(copies);
            calculateDiscount(copies, updatePrice);
        }

        function updatePrice(copies) {
            if (Object.keys(shipping_options).length > 1) {
                if ($elem.find('#priority-input:checked').val() == '1') {
                    // if (parseInt($copies.val()) == 1) {
                        shipping = shipping_options.express.price;
                        //$elem.find('#shipping-info').html('Delivery time ' + shipping_options.express.period);
                    // } else {
                    //     shipping = shipping_options.multiple.price;
                    //     //$elem.find('#shipping-info').html('Delivery time ' + shipping_options.multiple.period);
                    // }
                    $elem.find('#shipping-input').val('express');
                    $elem.find('.table-row-priority').show();
                } else {
                    shipping = shipping_options.normal.price;
                    // $elem.find('#shipping-info').html('Delivery time ' + (shipping_options.normal.period ? shipping_options.normal.period : '3-5 weeks'));
                    $elem.find('#shipping-input').val('normal');
                    $elem.find('.table-row-priority').hide();
                }
            }


            var copies_html = settings.copies_template.replace('{copies}', copies).replace('{price}', toEuro(price));
            var total_price = copies * price;

            if ($elem.find('#colour').val() === "white") {
                total_price += copies * white_price;
                copies_html = settings.copies_template.replace('{copies}', copies).replace('{price}', toEuro(price + white_price));
            }

            $elem.find('.order-table-copies').html(copies_html);

            var price_html = settings.price_template.replace('{price}', toEuro(total_price));
            $elem.find('.order-table-price').html(price_html);

            if(discount > 0) {
                var discount_html = settings.discount_template.replace('{discount}', toEuro(discount));
                $elem.find('.order-table-discount').html(discount_html);
                $elem.find('.table-row-discount').show();
            } else {
                $elem.find('.table-row-discount').hide();
            }

            var quantity = 0;
            if (copies > 1) {
                quantity = quantity_discount[copies][1]
                var quantity_html = settings.quantity_template.replace('{discount}', toEuro(quantity));
                $elem.find('.order-table-quantity').html(quantity_html);
                $elem.find('.table-row-quantity').show();
            } else {
                $elem.find('.table-row-quantity').hide();
            }

            var total = total_price - discount - quantity + shipping;
            var total_html = settings.total_template.replace('{price}', toEuro(total));
            $elem.find('.order-table-total').html(total_html);

            var total_tax = total - (total / (1+tax));
            var total_tax_html = settings.tax_template.replace('{price}', toEuro(total_tax));
            $elem.find('.order-table-tax').html(total_tax_html);
        }


        function toEuro(cents) {
            return parseFloat(cents / 100).toFixed(2);
        }


        function calculateDiscount(copies, callback) {
            if(codes.length == 0) {
                callback(copies);
                return;
            }

            var url = settings.codes_api+"/"+codes.join('||');
            $.get(url, { copies: copies, shipping: shipping, colour:  $('#colour').val()}, function(data)
            {
                $elem.find('.promo-codes').html('');
                codes = [];
                discount = data.discount;
                $.each(data.codes, function(i, v)
                {
                    if(v.state == 'valid') {
                        addCode(v.code);
                    }

                    if(i == $('#promo-input').val()) {
                        if(v.state == 'valid') {
                            $('#promo-input').val('');
                        } else {
                            $('#promo-input').addClass('error');
                        }
                    }
                });

                callback(copies);
            });
        }

        function addCode(code) {
            codes.push(code);
            $promocode = $('<div class="promo-code"></div>');
            $input = $('<input name="codes[]" value="'+code+'" type="hidden">');
            $text = $('<p>Code: '+code+'</p>');
            $promocode.append($input);
            $promocode.append($text);
            $('.promo-codes').prepend($promocode);
        }

    };

}( jQuery ));